import { __extends } from "tslib";
import { KinesisVideoClient } from "./KinesisVideoClient";
import { CreateSignalingChannelCommand, } from "./commands/CreateSignalingChannelCommand";
import { CreateStreamCommand, } from "./commands/CreateStreamCommand";
import { DeleteSignalingChannelCommand, } from "./commands/DeleteSignalingChannelCommand";
import { DeleteStreamCommand, } from "./commands/DeleteStreamCommand";
import { DescribeSignalingChannelCommand, } from "./commands/DescribeSignalingChannelCommand";
import { DescribeStreamCommand, } from "./commands/DescribeStreamCommand";
import { GetDataEndpointCommand, } from "./commands/GetDataEndpointCommand";
import { GetSignalingChannelEndpointCommand, } from "./commands/GetSignalingChannelEndpointCommand";
import { ListSignalingChannelsCommand, } from "./commands/ListSignalingChannelsCommand";
import { ListStreamsCommand } from "./commands/ListStreamsCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ListTagsForStreamCommand, } from "./commands/ListTagsForStreamCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { TagStreamCommand } from "./commands/TagStreamCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UntagStreamCommand } from "./commands/UntagStreamCommand";
import { UpdateDataRetentionCommand, } from "./commands/UpdateDataRetentionCommand";
import { UpdateSignalingChannelCommand, } from "./commands/UpdateSignalingChannelCommand";
import { UpdateStreamCommand, } from "./commands/UpdateStreamCommand";
/**
 * <p></p>
 */
var KinesisVideo = /** @class */ (function (_super) {
    __extends(KinesisVideo, _super);
    function KinesisVideo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KinesisVideo.prototype.createSignalingChannel = function (args, optionsOrCb, cb) {
        var command = new CreateSignalingChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.createStream = function (args, optionsOrCb, cb) {
        var command = new CreateStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.deleteSignalingChannel = function (args, optionsOrCb, cb) {
        var command = new DeleteSignalingChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.deleteStream = function (args, optionsOrCb, cb) {
        var command = new DeleteStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.describeSignalingChannel = function (args, optionsOrCb, cb) {
        var command = new DescribeSignalingChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.describeStream = function (args, optionsOrCb, cb) {
        var command = new DescribeStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.getDataEndpoint = function (args, optionsOrCb, cb) {
        var command = new GetDataEndpointCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.getSignalingChannelEndpoint = function (args, optionsOrCb, cb) {
        var command = new GetSignalingChannelEndpointCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.listSignalingChannels = function (args, optionsOrCb, cb) {
        var command = new ListSignalingChannelsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.listStreams = function (args, optionsOrCb, cb) {
        var command = new ListStreamsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.listTagsForResource = function (args, optionsOrCb, cb) {
        var command = new ListTagsForResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.listTagsForStream = function (args, optionsOrCb, cb) {
        var command = new ListTagsForStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.tagResource = function (args, optionsOrCb, cb) {
        var command = new TagResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.tagStream = function (args, optionsOrCb, cb) {
        var command = new TagStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.untagResource = function (args, optionsOrCb, cb) {
        var command = new UntagResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.untagStream = function (args, optionsOrCb, cb) {
        var command = new UntagStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.updateDataRetention = function (args, optionsOrCb, cb) {
        var command = new UpdateDataRetentionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.updateSignalingChannel = function (args, optionsOrCb, cb) {
        var command = new UpdateSignalingChannelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    KinesisVideo.prototype.updateStream = function (args, optionsOrCb, cb) {
        var command = new UpdateStreamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    return KinesisVideo;
}(KinesisVideoClient));
export { KinesisVideo };
//# sourceMappingURL=KinesisVideo.js.map